import React, { ReactElement, ReactNode } from 'react';
import { Col, Row, Text } from 'idsk-react-components';
import './detailTerminuRow.scss';
import { useResponsiveContext } from 'slovlex-idsk-react-components';

type DivisionType = 'quarters' | 'halves';

interface Props {
  header: string;
  children: ReactNode;
  division?: DivisionType;
}

const DetailTerminuRow = ({
  header, children, division = 'quarters',
}: Props): ReactElement => {
  const { isSmallScreen } = useResponsiveContext();
  const headerWidth = division === 'halves' ? 'one-half' : 'one-quarter';
  const contentWidth = division === 'halves' ? 'one-half' : 'three-quarters';
  return (
    <>
      {isSmallScreen ? (
        <Col>
          <Row className="detail-terminu-row">
            <Text type="div" className="detail-terminu-row-header">
              {header}
            </Text>
            <Text type="div" className="detail-terminu-row-text">{children}</Text>
          </Row>
        </Col>
      ) : (
        <>
          <Row className="detail-terminu-row">
            <Col width={headerWidth}>
              <Text type="span" className="detail-terminu-row-header">{header}</Text>
            </Col>
            <Col width={contentWidth}>
              <Text type="span" className="detail-terminu-row-text">{children}</Text>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default DetailTerminuRow;
